import { createSelector } from 'reselect';
import { selectCurrentCompanyFirstFiscalMonth } from 'modules/turnoverPage/selectors';
import {
  formatCommentsToMonths,
  formatMonthsCommentsToYear,
} from 'modules/commentsModal/helpers';

export const selectCommentsStatus = (state) => state.commentsModal?.status;

export const selectAllComments = (state) => state.commentsModal?.comments || [];

export const selectSubmitCommentFormStatus = (state) =>
  state.commentsModal?.submitFormStatus;

export const selectIsCommentsModalOpen = (state) =>
  state.commentsModal?.isModalOpen;

export const selectsDayForSort = (state) =>
  state.commentsModal?.dayIndexForSort;

export const selectMonthForSort = (state) =>
  state.commentsModal?.monthIndexForSort;

export const selectDateModeForSort = (state) =>
  state.commentsModal?.dateModeForSort;

export const selectChartTypeForSort = (state) => state.commentsModal?.chartType;

export const selectCommentsForModal = createSelector(
  [
    selectAllComments,
    selectsDayForSort,
    selectMonthForSort,
    selectDateModeForSort,
    selectChartTypeForSort,
  ],
  (comments, sortDay, sortMonth, sortMode, chartType) =>
    comments.filter(({ date, type }) => {
      const parsedDate = new Date(Date.parse(date));
      const day = parsedDate.getDate();
      const month = parsedDate.getMonth();
      if (sortMode === 'month') {
        return month === sortMonth && type === chartType;
      }
      return day === sortDay && month === sortMonth && type === chartType;
    })
);

export const selectTreasuryComments = createSelector(
  [(state) => state.commentsModal?.comments],
  (comments) =>
    comments ? comments.filter((comment) => comment.type === 'treasury') : []
);

export const selectTreasuryCommentsForChart = createSelector(
  [selectTreasuryComments],
  (treasuryComments) => formatCommentsToMonths(treasuryComments)
);

export const selectTreasuryCommentsForYearChart = createSelector(
  [selectTreasuryCommentsForChart, selectCurrentCompanyFirstFiscalMonth],
  (monthsComments, firstMonth) =>
    formatMonthsCommentsToYear(monthsComments, firstMonth)
);

export const selectTurnoverComments = createSelector(
  [(state) => state.commentsModal?.comments],
  (comments) =>
    comments ? comments.filter((comment) => comment.type === 'turnover') : []
);

export const selectTurnoverCommentsForChart = createSelector(
  [selectTurnoverComments],
  (turnoverComments) => formatCommentsToMonths(turnoverComments)
);

export const selectTurnoverCommentsForYearChart = createSelector(
  [selectTurnoverCommentsForChart, selectCurrentCompanyFirstFiscalMonth],
  (monthsComments, firstMonth) =>
    formatMonthsCommentsToYear(monthsComments, firstMonth)
);

export const selectDebtorsComments = createSelector(
  [(state) => state.commentsModal?.comments],
  (comments) =>
    comments ? comments.filter((comment) => comment.type === 'debtors') : []
);

export const selectDebtorsCommentsForChart = createSelector(
  [selectDebtorsComments],
  (turnoverComments) => formatCommentsToMonths(turnoverComments)
);

export const selectDebtorsCommentsForYearChart = createSelector(
  [selectDebtorsCommentsForChart, selectCurrentCompanyFirstFiscalMonth],
  (monthsComments, firstMonth) =>
    formatMonthsCommentsToYear(monthsComments, firstMonth)
);

export const selectCreditorsComments = createSelector(
  [(state) => state.commentsModal?.comments],
  (comments) =>
    comments ? comments.filter((comment) => comment.type === 'creditors') : []
);

export const selectCreditorsCommentsForChart = createSelector(
  [selectCreditorsComments],
  (turnoverComments) => formatCommentsToMonths(turnoverComments)
);

export const selectCreditorsCommentsForYearChart = createSelector(
  [selectCreditorsCommentsForChart, selectCurrentCompanyFirstFiscalMonth],
  (monthsComments, firstMonth) =>
    formatMonthsCommentsToYear(monthsComments, firstMonth)
);

export const selectHRComments = createSelector(
  [(state) => state.commentsModal?.comments],
  (comments) =>
    comments ? comments.filter((comment) => comment.type === 'hr') : []
);

export const selectHRCommentsForChart = createSelector(
  [selectHRComments],
  (HRComments) => formatCommentsToMonths(HRComments)
);

export const selectHRCommentsForYearChart = createSelector(
  [selectHRCommentsForChart, selectCurrentCompanyFirstFiscalMonth],
  (monthsComments, firstMonth) =>
    formatMonthsCommentsToYear(monthsComments, firstMonth)
);
